





























import Vue from 'vue';

import store from '@/store';

export default Vue.extend({
  props: {
    peerGroupId: Number,
    userId: Number,
    organizationId: Number,
    split: {
      type: Boolean,
      required: true
    },
    fixedLeftNav: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      iframeIsLoading: true,
      chartsURI: process.env?.VUE_APP_CHARTS_URL
    };
  },

  computed: {
    accessToken(): string {
      return store.state.auth.accessToken;
    }
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listenForIframeLoad(messageEvent: any) {
      console.log('loaded!', { messageEvent });

      if (messageEvent.data?.topic === 'appLoaded') {
        this.iframeIsLoading = false;

        (this.$refs
          .chartsIframe as HTMLIFrameElement).contentWindow?.postMessage(
          {
            topic: 'chartParameters',
            peerGroupId: this.peerGroupId,
            organizationId: this.organizationId,
            userId: this.userId
          },
          '*'
        );

        (this.$refs
          .chartsIframe as HTMLIFrameElement).contentWindow?.postMessage(
          {
            topic: 'unrulrToken',
            token: this.accessToken
          },
          '*'
        );
      }
    }
  },

  created() {
    window.addEventListener('message', this.listenForIframeLoad);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.listenForIframeLoad);
  }
});
